import React from 'react'
import PropTypes from 'prop-types'
import { useStyles } from '../styles'
import { useVaultContext } from '../../VaultContextProvider'
import { defaultDocumentDetailsLabel } from '../../constants'

export const DocumentDetailDescriptionBlock = ({
  document
}) => {
  const classes = useStyles()
  const { labels } = useVaultContext()

  return (
    <div className={classes.detailsBlock}>
      <div className={classes.detailBlockTitle}>
        {labels?.documentDetails?.description ?? defaultDocumentDetailsLabel.description}
      </div>
      <div className={classes.detailBlockContent}>{document.description}</div>
    </div>
  )
}

DocumentDetailDescriptionBlock.propTypes = {
  document: PropTypes.object.isRequired
}
